import styled from 'styled-components'

export const RowDiv = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .pagination-pages {
        padding: 8px;
        i {
            padding-left: 8px;
            padding-right: 8px;
            cursor: pointer;
        }
    }

    .pagination-perpages {
        padding: 8px;
        ul {
            min-width: min-content;
        }
    }
`
